import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import backgroundImage from '../../assets/background.png';
import logo from '../../assets/logo.png';
import './index.css';

const BASE_URL = 'https://www.whysocial.in/clap-kartel/public';

const Signup = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ lookingfor: '1', fullName: '', phoneNumber: '', emailId: '', password: '', confirmPassword: '' });
    const [formErrors, setFormErrors] = useState({});
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpCode, setOtpCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showPw, setShowPw] = useState(false);
    const [showCpw, setShowCpw] = useState(false);

    /* reCAPTCHA */
    const cleanupRecaptcha = () => {
        try { if (window.recaptchaVerifier) { window.recaptchaVerifier.clear(); window.recaptchaVerifier = null; } } catch (e) { }
        const c = document.getElementById('recaptcha-container'); if (c) c.innerHTML = '';
        if (window.grecaptcha) { try { document.querySelectorAll('.grecaptcha-badge').forEach(b => b.remove()); } catch (e) { } }
    };
    const setupRecaptcha = () => new Promise((resolve, reject) => {
        cleanupRecaptcha();
        setTimeout(() => { try { const v = new RecaptchaVerifier(auth, 'recaptcha-container', { size: 'invisible', callback: () => { }, 'expired-callback': () => cleanupRecaptcha(), 'error-callback': () => cleanupRecaptcha() }); window.recaptchaVerifier = v; resolve(v); } catch (err) { reject(err); } }, 300);
    });
    useEffect(() => () => { cleanupRecaptcha(); window.confirmationResult = null; }, []);

    /* Validation */
    const validate = () => {
        const e = {}; const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.fullName.trim()) e.fullName = 'Required';
        if (!formData.phoneNumber) e.phoneNumber = 'Required'; else if (formData.phoneNumber.length !== 10) e.phoneNumber = 'Enter 10 digits';
        if (!formData.emailId.trim()) e.emailId = 'Required'; else if (!re.test(formData.emailId)) e.emailId = 'Invalid email';
        if (!formData.password) e.password = 'Required'; else if (formData.password.length < 6) e.password = 'Min 6 characters';
        if (!formData.confirmPassword) e.confirmPassword = 'Required'; else if (formData.password !== formData.confirmPassword) e.confirmPassword = 'Passwords don\'t match';
        if (!agreeTerms) e.terms = 'Required';
        setFormErrors(e); return Object.keys(e).length === 0;
    };

    /* Handlers */
    const handleChange = (ev) => {
        const { name, value } = ev.target;
        if (name === 'phoneNumber') { const c = value.replace(/\D/g, ''); if (c.length <= 10) setFormData(p => ({ ...p, [name]: c })); }
        else setFormData(p => ({ ...p, [name]: value }));
        if (formErrors[name]) setFormErrors(p => ({ ...p, [name]: '' }));
        setError('');
    };
    const handleOtp = (ev) => { const v = ev.target.value.replace(/\D/g, ''); if (v.length <= 6) { setOtpCode(v); setError(''); } };

    const handleSubmit = async (ev) => {
        ev.preventDefault(); if (!validate()) return;
        setLoading(true); setError('');
        try { const v = await setupRecaptcha(); await v.render(); const c = await signInWithPhoneNumber(auth, `+91${formData.phoneNumber}`, v); window.confirmationResult = c; setOtpSent(true); }
        catch (err) { cleanupRecaptcha(); setError(err.code === 'auth/too-many-requests' ? 'Too many attempts' : err.message || 'Failed to send OTP'); }
        finally { setLoading(false); }
    };

    const verifyOtp = async () => {
        if (!otpCode || otpCode.length !== 6) { setError('Enter 6-digit OTP'); return; }
        setLoading(true); setError('');
        try {
            if (!window.confirmationResult) throw new Error('Request OTP first');
            const r = await window.confirmationResult.confirm(otpCode);
            const phone = r?.user?.phoneNumber || `+91${formData.phoneNumber}`;
            if (phone) localStorage.setItem('phoneNumber', phone);
            const res = await fetch(`${BASE_URL}/auth/register`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ fullName: formData.fullName, phoneNumber: phone, emailId: formData.emailId, password: formData.password, lookingfor: formData.lookingfor }) });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data?.message || 'Registration failed');
            const token = data?.token || data?.access_token || data?.data?.token;
            if (token) localStorage.setItem('token', token);
            navigate('/', { replace: true });
        } catch (err) { setError(err.code === 'auth/invalid-verification-code' ? 'Invalid OTP' : err.message || 'Failed'); }
        finally { setLoading(false); }
    };

    const handleVerifyOtp = (ev) => { ev.preventDefault(); verifyOtp(); };
    const handleResend = () => { setOtpSent(false); setOtpCode(''); setError(''); cleanupRecaptcha(); setTimeout(() => handleSubmit({ preventDefault: () => { } }), 500); };

    /* Icons */
    const I = ({ d }) => <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>;

    return (
        <div className="su-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className="su-page-overlay" />
            <div id="recaptcha-container" />

            <div className="su-card">
                <img src={logo} alt="Clap Kartel" className="su-card-logo" />
                <h1 className="su-card-title">Create Account</h1>
                <p className="su-card-sub">Sign up to get started</p>

                {/* Skills / Services */}
                <div className="su-provide">
                    <span className="su-provide-label">What do you want to provide?</span>
                    <div className="su-pills">
                        <label className={`su-pill ${formData.lookingfor === '1' ? 'active' : ''}`}>
                            <input type="radio" name="lookingfor" value="1" checked={formData.lookingfor === '1'} onChange={handleChange} disabled={otpSent || loading} />
                            Skills
                        </label>
                        <label className={`su-pill ${formData.lookingfor === '2' ? 'active' : ''}`}>
                            <input type="radio" name="lookingfor" value="2" checked={formData.lookingfor === '2'} onChange={handleChange} disabled={otpSent || loading} />
                            Services
                        </label>
                    </div>
                </div>

                {/* Fields */}
                <div className="su-row">
                    <div className="su-f">
                        <label>Full Name</label>
                        <div className={`su-box ${formErrors.fullName ? 'err' : ''}`}>
                            <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" /></svg>
                            <input type="text" name="fullName" placeholder="Enter your name" value={formData.fullName} onChange={handleChange} disabled={otpSent || loading} />
                        </div>
                        {formErrors.fullName && <span className="su-err">{formErrors.fullName}</span>}
                    </div>
                    <div className="su-f">
                        <label>Phone Number</label>
                        <div className={`su-box ${formErrors.phoneNumber ? 'err' : ''}`}>
                            <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 12 19.79 19.79 0 0 1 1 3.18 2 2 0 0 1 3 1h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                            <input type="tel" name="phoneNumber" placeholder="10-digit number" value={formData.phoneNumber} onChange={handleChange} maxLength="10" disabled={otpSent || loading} />
                        </div>
                        {formErrors.phoneNumber && <span className="su-err">{formErrors.phoneNumber}</span>}
                    </div>
                </div>

                <div className="su-f">
                    <label>Email ID</label>
                    <div className={`su-box ${formErrors.emailId ? 'err' : ''}`}>
                        <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                        <input type="email" name="emailId" placeholder="Enter your email" value={formData.emailId} onChange={handleChange} disabled={otpSent || loading} />
                    </div>
                    {formErrors.emailId && <span className="su-err">{formErrors.emailId}</span>}
                </div>

                <div className="su-row">
                    <div className="su-f">
                        <label>Password</label>
                        <div className={`su-box ${formErrors.password ? 'err' : ''}`}>
                            <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                            <input type={showPw ? 'text' : 'password'} name="password" placeholder="Create password" value={formData.password} onChange={handleChange} disabled={otpSent || loading} />
                            <button type="button" className="su-eye" onClick={() => setShowPw(p => !p)} tabIndex={-1}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">{showPw ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" /><line x1="1" y1="1" x2="23" y2="23" /></> : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></>}</svg>
                            </button>
                        </div>
                        {formErrors.password && <span className="su-err">{formErrors.password}</span>}
                    </div>
                    <div className="su-f">
                        <label>Confirm Password</label>
                        <div className={`su-box ${formErrors.confirmPassword ? 'err' : ''}`}>
                            <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                            <input type={showCpw ? 'text' : 'password'} name="confirmPassword" placeholder="Confirm password" value={formData.confirmPassword} onChange={handleChange} disabled={otpSent || loading} />
                            <button type="button" className="su-eye" onClick={() => setShowCpw(p => !p)} tabIndex={-1}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">{showCpw ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" /><line x1="1" y1="1" x2="23" y2="23" /></> : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></>}</svg>
                            </button>
                        </div>
                        {formErrors.confirmPassword && <span className="su-err">{formErrors.confirmPassword}</span>}
                    </div>
                </div>

                {/* Terms */}
                <div className="su-terms">
                    <input type="checkbox" id="suTerms" checked={agreeTerms} onChange={(e) => { setAgreeTerms(e.target.checked); if (formErrors.terms) setFormErrors(p => ({ ...p, terms: '' })); }} className="su-cb" disabled={otpSent || loading} />
                    <label htmlFor="suTerms" className="su-terms-txt">By signing up, you agree to our <span>Terms of Service</span> and <span>Privacy Policy</span>.</label>
                </div>
                {formErrors.terms && <span className="su-err" style={{ marginLeft: 28, marginTop: -4 }}>{formErrors.terms}</span>}

                {/* OTP */}
                {otpSent && (
                    <div className="su-f" style={{ marginTop: 8 }}>
                        <label>Enter OTP</label>
                        <div className="su-box">
                            <svg className="su-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" /></svg>
                            <input type="text" value={otpCode} onChange={handleOtp} onKeyDown={(e) => { if (e.key === 'Enter' && otpCode.length === 6) handleVerifyOtp(e); }} placeholder="6-digit code" maxLength="6" disabled={loading} />
                        </div>
                    </div>
                )}

                {error && <p className="su-global-err">{error}</p>}

                {!otpSent ? (
                    <button className="su-btn" onClick={handleSubmit} disabled={loading}>
                        {loading ? <><span className="su-spin" /> Sending...</> : 'Send Verification Code'}
                    </button>
                ) : (
                    <>
                        <button className="su-btn" onClick={handleVerifyOtp} disabled={loading || otpCode.length !== 6}>
                            {loading ? <><span className="su-spin" /> Verifying...</> : 'Verify OTP'}
                        </button>
                        <button className="su-btn-ghost" onClick={handleResend} disabled={loading} type="button">Resend OTP</button>
                    </>
                )}

                <p className="su-foot">Already have an account? <Link to="/login" className="su-foot-link">Sign in</Link></p>
            </div>
        </div>
    );
};

export default Signup;